import React from "react";

export default function Card({
  children,
  className = "",
  style = {},
  ...props
}) {
  return (
    <div
      className={`p-[2%] mb-[2%] rounded-[3px] shadow-[0_0_5px_2px_#aaafb3] ${className}`}
      style={style}
      {...props}
    >
      {children}
    </div>
  );
}